import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate ,useLocation} from "react-router-dom";
import "./login.css";
import  Loading from '../../components/Loading/loading'
import { useDispatch, useSelector } from "react-redux";
import { clearError, login, register } from '../../actions/userAction'
import { toast } from "react-toastify";
import { FiLock } from "react-icons/fi";
import { MdEmail } from "react-icons/md";

const Login = () => {
  const { error, loading, isAuthenticated } = useSelector((state) => state.users)
  const [loginEmail, setloginEmail] = useState();
  const [loginPassword, setloginPassword] = useState();
  const dispatch = useDispatch();
  const location = useLocation()

const navigate=useNavigate()
// const redirect = location.search ? location.search.split("=")[1] : "/account";

  useEffect(() => {
    // console.log(error)
    if(error){
      toast.error(error)
      dispatch(clearError())
    }
    if(isAuthenticated){
      navigate('/dashboard')
      // toast.error(" login")

    }
   
  }, [error, isAuthenticated]);
  const loginHandler = (e) => {
    e.preventDefault();
    dispatch(login(loginEmail,loginPassword))
    console.log("login");
  };
  return (
     <Fragment>
       {
        loading ? (<Loading/>) : (
          <div className="loginContainer">
          <div className="imgBox">
            <img src={require('../../images/login.avif')} alt="" />
          </div>
          <div>
            <div className="formBox">
              <h2>Login</h2>
              <form action="" onSubmit={loginHandler}>
                <div>
                  <MdEmail />
                  <input type="email" className="logInpBtn" placeholder="name" value={loginEmail} onChange={(e)=>setloginEmail(e.target.value)}  />
                </div>
                <div>
                  <FiLock />
                  <input
                    type="password"
                    className="logInpBtn"
                    placeholder="password"
                    value={loginPassword} onChange={(e)=>setloginPassword(e.target.value)}
                  />
                </div>
                <div>
                  <input type="submit" className="submintBtn" placeholder="name"  />
                </div>
              </form>
              <div className="regBox">
                {/* <p>I m New </p> */}
                <Link to={"/forget/password"}>Forget Password</Link>
                {/* <Link className="submintBt" to={"/register"}>
                  Sign up
                </Link> */}
    
              </div>
            </div>
          </div>
        </div>
        )
      }
     </Fragment>
  );
};

export default Login;
